import { render, staticRenderFns } from "./BoatForm.vue?vue&type=template&id=d4909c90&"
import script from "./BoatForm.vue?vue&type=script&lang=js&"
export * from "./BoatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports